import { render, staticRenderFns } from "./WithoutProspecting.vue?vue&type=template&id=1af8b2b1&"
import script from "./WithoutProspecting.vue?vue&type=script&lang=ts&"
export * from "./WithoutProspecting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports